<script setup lang="ts">
import type { FactoryArg, MaskedDynamic, MaskedDynamicOptions } from 'imask'

defineOptions({
  inheritAttrs: false,
})

type MaskType = 'phone' | 'digits' | 'login'

const props = withDefaults(defineProps<{
  modelValue?: string
  mask?: MaskType
}>(), {
  modelValue: '',
  mask: 'phone',
})

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void
}>()

const maskOptions = computed<FactoryArg>(() => {
  if (props.mask === 'digits') return { mask: /^\d{0,12}$/ }
  if (props.mask === 'login') {
    return {
      mask: [
        { mask: '+7 (000) 000-00-00' },
        { mask: /^\S*@?\S*$/ },
      ],
      dispatch(appended: string, dynamicMasked: MaskedDynamic) {
        const value = dynamicMasked.value + appended
        return dynamicMasked.compiledMasks[/[a-zа-я@]/i.test(value) ? 1 : 0]
      },
    } satisfies MaskedDynamicOptions
  }
  return { mask: '+7 (000) 000-00-00' }
})
</script>

<template>
  <UiMaskProvider
    :mask-options="maskOptions"
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <UiInput v-bind="$attrs" :inputmode="mask === 'login' ? 'text' : 'numeric'" />
  </UiMaskProvider>
</template>
